'use client'

import React from 'react';
import Link from "next/link";

const TopStrip = () => {
    
  return (
    <div className="bg-pink-600 px-10 py-6 rounded-lg mt-6">
        <div className="flex justify-between items-center">
            <div>
               <h1
  style={{
    fontSize: '1.4rem',
    color: '#000000',
    fontFamily: 'Roboto, sans-serif',
    lineHeight: '1.2',  // Reduce line height for less gap between lines
  }}
  className="font-bold mb-1"
>
  {/* Remove block behavior by making span inline and controlling colors */}
  <span style={{ color: 'white' /* emerald-600 */, fontWeight: 'bold' }}>
    100% Natural Quality Organic Product
  </span>
</h1>      
                <p className="text-gray-500 text-white">See Our latest discounted products from here and get a special discount product</p>
            </div>
            <Link
              href="tel:+91-72898-59266"
              className="text-sm font-serif font-medium px-6 py-2 text-center rounded-full transition duration-300"
              style={{
                border: '2px solid #DB2777',
                backgroundColor: 'white',
                color: '#DB2777',
                textDecoration: 'none',
                display: 'inline-block',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'yellow';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
              }}
            >
              <b>Call Us</b>
            </Link> 
        </div>
    </div>
  );
};

export default TopStrip;
